import React from 'react';
import { useLocation } from 'react-router-dom';
import View3D from '@egjs/react-view3d';
import '@egjs/react-view3d/css/view3d-bundle.min.css';
import mouseCursor from '../assets/mouse-cursor.png';
import control from '../assets/control.png';
import annotationURL from '../assets/model-annotations.json'

function ViewModel() {
    const location = useLocation();
    const { model } = location.state || {};
    const { artifact } = location.state || {}; // Get the model from state

    if (!model) {
        return <div>No model provided.</div>; // Handle case where no model is provided
    }

    return (
        <div style={{ position: 'relative', width: '100%', height: '550px' }}>
            <View3D
                tag="div"
                src={model} // Use the model URL here
                axes={true}
                onReady={(e) => {
                    console.log("3D model is ready", e);
                }}
                style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '10px',
                    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
                }}
            >
                {artifact._id === '66dc07373686bbe9d4676b27' && (
                    <div className="view3d-annotation-wrapper">
                    <div className="view3d-annotation default" data-position="0.02 0.1 -0.1" data-focus="-90 0 30">
                    <div className="view3d-annotation-tooltip default">
                    Size: 5 mm

                    Colour: brass-yellow with metallic luster

                    Chemical composition: FeS2
                    </div>
                    </div>

                    <div className="view3d-annotation default" data-position="0.05 0.25 0.1" data-focus="0 0 0">
                    <div className="view3d-annotation-tooltip default">
                    Fine-grained sandstone
                    </div>

                    <div className="view3d-annotation default" data-position="0.10 0.1 -0.15" data-focus="-90 0 30">
                    <div className="view3d-annotation-tooltip default">
                    Aggregate of 3 cubic pyrite crystal

                    Size (2 to 5 mm per crystal)
                    </div>
                    </div>
                    </div>
                </div>
                )}
            </View3D>
            {/* Controls and other UI elements can be added here */}
            <div style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                display: 'flex',
                gap: '10px',
                background: 'white',
                padding: '10px',
                borderRadius: '20px',
                flexDirection: 'column'
            }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-cursor-fill" viewBox="0 0 16 16">
                        <path d="M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103z" />
                    </svg>
                    <span style={{ marginLeft: '4px' }}>Rotate</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={mouseCursor} style={{ width: '20px', height: '20px' }} />
                    <span>Zoom in / Zoom out</span>
                </div>
                {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={control} style={{ width: '20px', height: '20px' }} /> +
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-cursor-fill" viewBox="0 0 16 16">
                        <path d="M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103z" />
                    </svg>
                    <span style={{ marginLeft: '4px' }}>Drag</span>
                </div> */}
            </div>
            {/* Menu buttons for Fullscreen, Annotations, etc. */}
            <div style={{ position: 'absolute', bottom: '10px', right: '10px', display: 'flex', gap: '10px' }}>
                <button
                    onClick={() => document.querySelector('canvas').requestFullscreen()}
                    style={buttonStyle}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrows-fullscreen" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707" />
                    </svg>
                </button>
            </div>
        </div>
    );
}

const buttonStyle = {
    background: '#fff',
    border: '1px solid #ccc',
    padding: '5px 10px',
    borderRadius: '5px',
    cursor: 'pointer',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.3)',
};

export default ViewModel;
